/**
* 单题在班级内的详情
*/
<template>
    <span>
        <a @click="openmodel()">详情</a>
        <a-modal :visible="visible" :width="1280" title="题目详细情况" @ok="okmodel" @cancel="cancelmodel">

            <a-list item-layout="vertical" :data-source="questionList">
                <a-list-item slot="renderItem" key="item.title" slot-scope="item">
                    <a-list-item-meta>

                        <div slot="title">
                            <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                v-if="item.typestr == 'ANSWER'">问答题
                            </a-tag>
                            <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                v-if="item.typestr == 'PREVIEW'">预习题
                            </a-tag>
                            <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                v-if="item.typestr == 'JUDGMENT'">判断题
                            </a-tag>
                            <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                v-if="item.typestr == 'COMPLETION'">填空题
                            </a-tag>
                            <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'VIDEO'">口述题
                            </a-tag>
                            <a-tag color="#87d068" style="float: left; margin-right: .5rem"
                                v-if="item.typestr == 'SINGLE_CHOICE'">单选题
                            </a-tag>
                            <div v-html="item.title" />
                        </div>
                        <template slot="description">
                            <a-row :gutter="16" v-if="item.typestr == 'SINGLE_CHOICE'">
                                <a-col :span="6" v-for="option in item.options" :key="option.value">
                                    <div class="option">
                                        <label class="label">{{ option.keys }}:</label>

                                        <div class="span" v-html="option.value" />
                                    </div>
                                </a-col>
                            </a-row>
                            <div>
                                <span v-if="item.typestr == 'ANSWER' || item.typestr == 'VIDEO'">参考答案:</span>
                                <span
                                    v-if="item.typestr == 'JUDGMENT' || item.typestr == 'COMPLETION' || item.typestr == 'SINGLE_CHOICE'">答案:</span>
                                <span>{{ item.answer }}</span>
                            </div>
                        </template>
                    </a-list-item-meta>
                    <div>
                        <a-rate :value="item.star"></a-rate>
                        <a-divider type="vertical" v-if="item.tag.length > 0"></a-divider>
                        <a-tag v-for="tag in item.tag" :key="tag" color="#2db7f5">{{ tag }}</a-tag>
                        <a-divider v-if="item.previewvideo != ''" type="vertical"></a-divider>
                        <template v-if="item.systag != 0">
                            <a-tag color="#2db7f5">相似题</a-tag>
                            <a-divider type="vertical" />
                        </template>
                        <or-preview v-if="item.previewvideo != ''" text="预习视频" :videoUrl="item.previewvideo" />
                        <or-preview v-if="item.analysisvideo != ''" text="解析视频" :videoUrl="item.analysisvideo" />
                        <squadquestion v-bind:itemdata="item" v-bind:squad_id="squad_id" v-bind:mission_id="mission_id">
                        </squadquestion>
                    </div>

                </a-list-item>
            </a-list>






        <!-- <a-row :gutter="16" style="margin-left: 50px">
                <a-col :span="6">

                    <a-statistic title="班级人数" :value="itemdata.actual">
                        <template #suffix>
                            <a-icon type="like" />
                        </template>
                    </a-statistic>
                </a-col>
                <a-col :span="6">
                    <a-statistic title="应参" :value="itemdata.statistic" class="demo-class">
                      
                    </a-statistic>
                </a-col>

                <a-col :span="6">
                    <a-statistic title="不参" :value="itemdata.actual-itemdata.statistic" class="demo-class">
                    
                        </a-statistic>
                    </a-col>
                </a-row> -->


            <a-divider></a-divider>

            <div>
                <a-table :dataSource="tabledata" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
                    @change="onPaginationChange" bordered>
                    <a-table-column key="user_name" title="姓名" data-index="user_name" />

                    <a-table-column key="tj_time_count" title="完成时间"
                        :sorter="(item1, item2) => item1.tj_time_count - item2.tj_time_count">
                        <template slot-scope="item">
                            {{ parseFloat(item.tj_time_count / 1000).toFixed(0) }}秒
                        </template>
                    </a-table-column>

                    <a-table-column key="user_answer" title="答案"
                        :sorter="(item1, item2) => item1.user_answer - item2.user_answer">
                        <template slot-scope="item">
                            <span v-html="item.user_answer"></span>
                        </template>

                    </a-table-column>

                    <a-table-column key="isright" title="正确" :sorter="(item1, item2) => item1.isright - item2.isright">
                        <template slot-scope="item">
                            <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.isright == '1'">对
                            </a-tag>
                            <a-tag color="#AA1111" style="float: left; margin-right: .5rem"
                                v-if="item.isright == '0' && item.tj_time_count > 0">错
                            </a-tag>

                            <a-tag color="#00230B" style="float: left; margin-right: .5rem"
                                v-if="item.isright == '0' && item.tj_time_count == '0'">未完成
                            </a-tag>
                        </template>
                    </a-table-column>
                    <!--    <a-table-column key="missiontypename" title="任务类型" data-index="missiontypename" /> -->


                </a-table>
                <div>总共{{ pageinfo.total }}条数据</div>
                <a-switch size="small" v-model="showcount" @change="getshowcount" />
            </div>

        </a-modal>
    </span>
</template>
<script>
//   import  squadusermodel from '@/views/orgpublish/squadusermodel.vue';
export default {
    components: {},
    props: {
        itemdata: {},
        squad_id: undefined,
        mission_id: undefined
    },
    data() {
        return {
            data: [],
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 10
            },
            showcount: false,
            tabledata: [],
            loading: false,
            visible: false,
            squadinfo: [],
            missioninfo: [],
            usermission: [],
            questionList: [],
        };
    },
    mounted() {

    },
    computed: {

    },
    methods: {
        getshowcount() {
            if (this.showcount) {
                this.pageinfo.pageSize = 9999;
                this.pageinfo.current = 1;
                // this.showcount=true;
            }
            if (!this.showcount) {
                this.pageinfo.pageSize = 10;
                this.pageinfo.current = 1;
                // this.showcount=false;
            }
            this.getTableList();
        },
        /* getsquadinfo() {
             this.$axios
                 .post("/api/OrgSquad/getinfo", {
                     data: {
                         id: this.squad_id
                     }
                 })
                 .then(res => {
                     if (res.code != 200) {
                         this.$error({
                             title: "错误",
                             content: res.msg,
                             okText: "确定"
                         });
                     } else {
                         this.squadinfo = res.data;
                     }
                 })
                 .catch(err => {
                     console.error(err);
                 }).finally(() => {
                     this.loading = false;
                 })

         },
         */
        /* getmissioninfo() {
             this.$axios
                 .post("/api/CoreSquadMission/getCoreSquadMissioninfo", {
                     data: {
                         squad_id: this.squad_id,
                         mission_id:this.mission_id
                     }
                 })
                 .then(res => {
                     if (res.code != 200) {
                         this.$error({
                             title: "错误",
                             content: res.msg,
                             okText: "确定"
                         });
                     } else {
                         this.missioninfo = res.data;
                         this.getproblemslist(this.missioninfo.testpaper_id);
                     }
                 })
                 .catch(err => {
                     console.error(err);
                 }).finally(() => {
                     this.loading = false;
                 })
         
         },
         getproblemslist(testpaper_id) {
           this.$axios
             .post("/api/QuestionProblems/getproblemslist", {
               data: {testpaper_id: testpaper_id}
             })
             .then(res => {
               if (res.code != 200) {
                 this.$error({
                   title: "错误",
                   content: res.msg,
                   okText: "确定"
                 });
               } else {
                 this.questionList = res.data;
                 for (let i = 0; i < this.questionList.length; i++) {
                   if (this.questionList[i]["tag"] != "") {
                     this.questionList[i]["tag"] = this.questionList[i][
                       "tag"
                       ].split(",");
                   }
                 }
         
               }
             })
             .catch(err => {
               console.error(err);
             });
           this.visible = true;
         },
         */

        getTableList() {
            //  this.searchFrom.squad_id=this.itemdata.id;
            this.loading = true;
            this.$axios
                .post("/api/AnalyseInfo/getuserbyproblems", {
                    data: {
                        squad_id: this.squad_id,
                        mission_id: this.mission_id,
                        problems_id: this.itemdata.id
                    },
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                        this.tabledata = null;
                    } else {
                        this.tabledata = res.data.data;
                        this.pageinfo = res.data.pageinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        },

        openmodel() {
            this.visible = true;
            this.questionList[0] = this.itemdata;
            // this.getmissioninfo();
            //  this.getsquadinfo();
            this.getTableList();
        },
        okmodel() {
            this.visible = false;
        },
        cancelmodel() {
            this.visible = false;
        },

        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getTableList();
        },


    }
};
</script>
<style>
.active_btn {
    margin-left: 5px;


}
</style>
